// import angular from "angular";
import $pageConfig from "webutils/services/page-config";

export default class AutoQueryRadioFilter {
  constructor(config, $aq) {
    const g = this;
    g.options = [];
    g.type = "radio";
    Object.assign(g, config);
    g.query = $aq;
    g.bus = $aq.bus;
    if (!g.title) g.title = g.radio;
    if (config.$onInit) {
      g.$$initialized = config.$onInit(g, config, $aq);
    }
    if (config.$onLoad) {
      g.$$loaded = config.$onLoad(g, config, $aq);
    }
  }

  isSelected(option) {
    const g = this;
    if (option.isSelected) {
      return option.isSelected(g);
    }
    return !!g.query.criteria[option.fieldName];
  }

  readQueryString(fieldName, value) {
    const g = this;
    const memo = {};
    g.options.forEach((o) => {
      if (o.fieldName.toLowerCase() === fieldName.toLowerCase()) {
        g.initialValue = value;
        if (value === o.value(g)) {
          g.query.criteria[o.fieldName] = value;
          memo[o.fieldName] = value;
        } else if (!(o.fieldName in memo)) {
          delete g.query.criteria[o.fieldName];
        }
      } else {
      }
    });
  }

  writeQueryString(params) {
    const g = this;
    const memo = {};
    g.options.forEach((o) => {
      if (g.isSelected(o)) {
        params[o.fieldName] = o.value(g);
        memo[o.fieldName] = params[o.fieldName];
      } else if (!(o.fieldName in memo)) {
        delete params[o.fieldName];
      }
    });
  }

  scrubParams(_params) {
    const g = this;
    let params = { ..._params };
    g.options.forEach((o) => {
      delete params[o.fieldName];
    });
    delete params.page;
    delete params.pageSize;
    delete params.orderBy;
    delete params.fields;
    delete params.Fields;
    return params;
  }

  process(_params) {
    const g = this;
    if (g.hidden) return false;
    let params = g.scrubParams(_params);
    params.sortBy = params.take = params.skip = null;
    return g.options;
  }

  any() {
    const g = this;
    return g.options.filter((o) => g.isSelected(o)).length;
  }

  clear() {
    const g = this;
    g.options.forEach((o) => {
      delete g.query.criteria[o.fieldName];
    });
  }

  getRefinements() {
    const g = this;
    if (g.hidden && !g.showRefinement) return [];
    return g.options
      .filter((o) => g.isSelected(o))
      .map((o) => ({
        label: g.formatter ? g.formatter(o) : o.label,
        remove: g.toggle.bind(g, o),
      }));
  }

  toggle(option) {
    const g = this;
    if (option.toggle) {
      option.toggle(g);
    } else {
      g.options.forEach((o) => {
        if (option === o && !g.query.criteria[o.fieldName]) {
          g.query.criteria[o.fieldName] = o.value(g);
        } else {
          delete g.query.criteria[o.fieldName];
        }
      });
      g.query.load(true);
    }
    this.query.scrollTop && $pageConfig && $pageConfig.goTop();
  }
}
